<div class="wrapper">
  <div class="loader">
    <progress
      class="loader__progress"
      max="100"
      [value]="questionData().percentage"
    ></progress>
    <span class="loader__percentage">{{ questionData().percentage }}%</span>
  </div>

  <h2 class="title">{{ questionData().question }}</h2>

  @if (questionData().subtitle) {
    <p class="subtitle">
      {{ questionData().subtitle }}
    </p>
  }

  @if (questionData().info; as info) {
    <button
      class="link btn-info"
      (click)="requestInfo.emit(info.target)"
      wlAutomationId="questionnaire-moreInfo"
    >
      {{ info.label }}
    </button>
  }

  <div class="options">
    @for (option of questionData().options; track option) {
      <button
        class="btn btn-outline-primary options__button"
        (click)="submitAnswer.emit(option)"
        [wlAutomationId]="option.automationId"
      >
        {{ option.label }}
      </button>
    }
  </div>

  @if (showPrevious()) {
    <button
      class="btn btn-link btn-previous"
      (click)="back.emit()"
      wlAutomationId="questionnaire-previousQuestion"
    >
      <fa-icon icon="arrow-left" />
      {{ rendering.previousLabel }}
    </button>
  }
</div>
